
<!-- Header that allows for selecting the Infrastructure subpage to be on -->
<app-infrastructure-header [title]='"TAGS"'></app-infrastructure-header>

<!-- Main Screen which shows the Tags and Tag Instances -->
<div style="clear: both" id="objectContentPane">
	<div style="margin: 12px">

		<!-- Tab Navigation Control -->
		<ul class="nav nav-tabs">
			<li class="active"><a data-toggle="tab" href="#tag-instances-tab" aria-expanded="true"><i class="fa fa-star-o"></i> TAGS</a></li>
			<li class=""><a data-toggle="tab" href="#tags-tab" aria-expanded="false"><i class="fa fa-star-o"></i> TAG TYPES</a></li>
		</ul>

		<!-- Tab Content -->
		<div class="tab-content">

			<!-- Tags Tab -->
			<div id="tags-tab" class="tab-pane fade">

				<!-- Add Tag Type and Options buttons -->
				<button (click)="addTagDefinitionClicked()" type="button" class="btn btn-ef"><em
						class="fa fa-plus"></em> ADD TAG TYPE</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedTagDefinitionClicked()"
							[class.disabled]="!isSingleTagDefinitionSelected()"><a><em class="fa fa-pencil"></em>
								EDIT</a></li>
						<li (click)="duplicateSelectedTagDefinitionClicked()"
							[class.disabled]="!isSingleTagDefinitionSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedTagDefinitionsClicked()"
							[class.disabled]="!isAnyTagDefinitionsSelected()"><a><em class="fa fa-remove"></em>
								DELETE</a></li>
						<li class="divider"></li>
						<li (click)="addSelectedTagDefinitionsToGroupClicked()"
							[class.disabled]="!isAnyTagDefinitionsSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedTagDefinitionsFromGroupClicked()"
							[class.disabled]="!isAnyTagDefinitionsSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageTagDefinitionGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
						<li class="divider"></li>
						<li (click)="uploadTypeFileClicked()"><input type="file" #typeFileUpload
								(change)="onTypeFileUploadChange($event)" style="display:none" /><a><em
									class="fa fa-upload"></em> UPLOAD TYPES </a></li>
						<li (click)="downloadTypes()"><a><em class="fa fa-download"></em> DOWNLOAD TYPES </a></li>
						<li (click)="downloadTags()" [class.disabled]="!isSingleTagDefinitionSelected()"><a><em
									class="fa fa-download"></em> DOWNLOAD TAGS </a></li>
					</ul>
				</div>

				<!-- Filter (dropdown + type-aware value input) -->
				<app-filter-bar
					[options]="filterOptionsForTagDefinition"
					[(selected)]="selectedFilterOptionForTagDefinition"
					(filterChanged)="onTagDefinitionFilterChanged($event)">
				</app-filter-bar>

				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForTypes(value)" [class.active]="value === selectedPageSizeValueForTypes">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>

				<!-- Tags -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table1"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllTagDefinitionsSelected()"
										(change)="setAllTagDefinitionsSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header tablesorter-headerUnSorted">Name</div>
								<!-- <div class="tablesorter-header-inner" (click)="sortTag('name')">Name
									<ng-container *ngIf="(sortOrder['name'] == 'ASC')"><em
											class="fa fa-arrow-down"></em></ng-container>
									<ng-container *ngIf="(sortOrder['name'] == 'DESC')"><em class="fa fa-arrow-up"></em>
									</ng-container>
								</div> -->
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let tag of mTagDefinitions | paginate: {id: 'tag_pagination', itemsPerPage: selectedPageSizeValueForTypes, currentPage: currentPageTag, totalItems: numberTags }">
							<tr class="" role="row">
								<td><input type="checkbox" (click)="selectTagDefinition(tag)"
										[checked]="isTagDefinitionSelected(tag)" /></td>
								<td (click)="editTagDefinition(tag)">{{tag.name}}</td>
								<td>
									<ng-container *ngIf="tag.groups != null && tag.groups.length > 0">
										<ng-container *ngFor="let group of tag.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-clip-rotate">
					<p style="font-size: 20px; color: white">Loading...</p>
				</ngx-spinner>

				<table border="0" width="100%">
					<tr>
						<td>

							<pagination-controls class="pagination" id="tag_pagination"
								(pageChange)="filterStringChangedTag($event)" [directionLinks]="true" nextLabel="Next"
								previousLabel="Prev" [autoHide]="true">
							</pagination-controls>
						</td>
						<!--	KHT 08/11/2021 - replaced this custom pagination with ngx-pagination to match rest of app 
							<td style="padding-left: 20px;" *ngIf="numberTagPages > 1">
							Page <input id="pageTag" class="form-control ng-pristine ng-valid ng-untouched"
								style="display: inline; width: 70px" type="text" size="4" value="{{ currentPageTag }}">
							of {{ roundUp(numberTagPages) }}
							<button class="btn btn-ef" (click)="currentPageChangedTag()">GO</button>
						</td>-->
						<td>&nbsp;</td>
					</tr>
				</table>
			</div>

			<!-- Tag Instances Tab -->
			<div id="tag-instances-tab" class="tab-pane fade active in">

				<!-- Add Tag and Options buttons -->
				<button (click)="addTagInstanceClicked()" type="button" class="btn btn-ef"><em class="fa fa-plus"></em>
					ADD TAG</button>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-th"></em> OPTIONS <span class="caret"></span></button>
					<ul class="dropdown-menu">
						<li (click)="editSelectedTagInstanceClicked()"
							[class.disabled]="!isSingleTagInstanceSelected()"><a><em class="fa fa-pencil"></em> EDIT</a>
						</li>
						<li (click)="duplicateSelectedTagInstanceClicked()"
							[class.disabled]="!isSingleTagInstanceSelected()"><a><em class="fa fa-clone"></em>
								DUPLICATE</a></li>
						<li (click)="deleteSelectedTagInstancesClicked()"
							[class.disabled]="!isAnyTagInstancesSelected()"><a><em class="fa fa-remove"></em> DELETE</a>
						</li>
						<li class="divider"></li>
						<li (click)="addSelectedTagInstancesToGroupClicked()"
							[class.disabled]="!isAnyTagInstancesSelected()"><a><em class="fa fa-plus"></em> ADD TO
								GROUP</a></li>
						<li (click)="removeSelectedTagInstancesFromGroupClicked()"
							[class.disabled]="!isAnyTagInstancesSelected()"><a><em class="fa fa-remove"></em> REMOVE
								FROM GROUP</a></li>
						<li (click)="manageTagInstanceGroupsClicked()"><a><em class="fa fa-pencil"></em> MANAGE
								GROUPS</a></li>
						<li class="divider"></li>
						<li (click)="uploadTagFileClicked()"><input type="file" #fileTagUpload
								(change)="onTagFileUploadChange($event)" style="display:none" /><a><em
									class="fa fa-upload"></em> UPLOAD TAGS </a></li>
					</ul>
				</div>

				<!-- Filter (multiple filters AND'd together: Name + Is Deactivated) -->
				<app-filter-bar
					[multiple]="true"
					[options]="filterOptionsForTagInstance"
					[(active)]="activeFiltersForTagInstance"
					(filterChanged)="onTagInstanceFilterChanged($event)">
				</app-filter-bar>
				<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
					<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown"><em
							class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span></button>
							<ul class="dropdown-menu">
								<li *ngFor="let value of resultsPerPageValues" (click)="manageResultPerPageClickedForInstances(value)" [class.active]="value === selectedPageSizeValueForInstances">
									<a>{{ value }}</a>
								</li>
							</ul>
				</div>

				<!-- Tag Instances -->
				<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table"
					data-id-field="userid" role="grid">
					<thead>
						<tr role="row" class="tablesorter-headerRow">
							<th data-column="0" class="tablesorter-header tablesorter-headerUnSorted" tabindex="0"
								scope="col" role="columnheader" aria-disabled="false" aria-controls="table2"
								aria-sort="none" aria-label=": No sort applied, activate to apply an ascending sort"
								style="user-select: none;">
								<div class="tablesorter-header-inner">
									<input type="checkbox" [checked]="isAllTagInstancesSelected()"
										(change)="setAllTagInstancesSelected($event)" />
								</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Name: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header tablesorter-headerUnSorted">Name</div>
								<!-- Sort Functions Commented out. Can implemented when required -->
								<!-- <div class="tablesorter-header-inner" (click)="sortTagInstance('name')">Name -->
									<!-- <ng-container *ngIf="(sortOrder['instance_name'] == 'ASC')"><em
											class="fa fa-arrow-down"></em></ng-container>
									<ng-container *ngIf="(sortOrder['instance_name'] == 'DESC')"><em
											class="fa fa-arrow-up"></em></ng-container> -->
								<!-- </div> -->
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="object" data-sortable="true" data-column="2" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Asset Type: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Tag Type</div>
							</th>
							<th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
								data-field="groups" data-sortable="true" data-column="3" tabindex="0" scope="col"
								role="columnheader" aria-disabled="false" aria-controls="table2" aria-sort="none"
								aria-label="Groups: No sort applied, activate to apply an ascending sort">
								<div class="tablesorter-header-inner">Groups</div>
							</th>
						</tr>
					</thead>
					<tbody aria-live="polite" aria-relevant="all">
						<ng-container
							*ngFor="let tagInstance of mTagInstances | paginate: {id: 'taginstance_pagination', itemsPerPage: selectedPageSizeValueForInstances, currentPage: currentPageTagInstance, totalItems: numberTagInstances}">
							<tr class="" role="row">
								<td><input type="checkbox" (click)="selectTagInstance(tagInstance)"
										[checked]="isTagInstanceSelected(tagInstance)"/></td>
								<td (click)="editTagInstance(tagInstance)" (contextmenu)="fetchFunctionList($event, tagInstance)">{{tagInstance.name}}</td>
								<td (click)="editTagInstance(tagInstance)">{{tagInstance.asset.name}}</td>
								<td>
									<ng-container *ngIf="tagInstance.groups != null && tagInstance.groups.length > 0">
										<ng-container *ngFor="let group of tagInstance.groups">
											<button class="groupButton"
												(click)="showGroup(group)">{{group.name}}</button>
										</ng-container>
									</ng-container>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>

				<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-clip-rotate">
					<p style="font-size: 20px; color: white">Loading...</p>
				</ngx-spinner>
				<table border="0" width="100%">
					<tr>
						<td>
							<pagination-controls class="pagination" id="taginstance_pagination"
								(pageChange)="filterStringChangedTagInstance($event)" [directionLinks]="true"
								nextLabel="Next" previousLabel="Prev" [autoHide]="true">
							</pagination-controls>
						</td>
						<!--	KHT 08/11/2021 - replaced this custom pagination with ngx-pagination to match rest of app  
							<td style="padding-left: 20px;">
							Page <input id="pageTagInstance" class="form-control ng-pristine ng-valid ng-untouched"
								style="display: inline; width: 70px" type="text" size="4"
								value="{{ currentPageTagInstance }}">
							of {{ roundUp(numberTagInstancePages) }}
							<button class="btn btn-ef" (click)="currentPageChangedTagInstance()">GO</button>
						</td> -->
						<td>&nbsp;</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</div>

<app-entity-type-dialog #entityTypeDialog [entity]="mEntity" [entityName]="mEntityName" [entityType]="mEntityType"
	[entityTypeName]="mEntityTypeName" (createOrUpdateEvent)="createOrUpdateEntityType()"
	(showGroup)="showGroup($event)">
</app-entity-type-dialog>

<app-entity-instance-dialog #entityInstanceDialog [instance]="mInstance" 
	[instanceName]="mInstanceName" [instanceEntityType]="mInstanceEntityType" [instanceType]="mInstanceType"
	[instanceTypeName]="mInstanceTypeName" [availableEntityTypes]="mAvailableEntityTypes"
	(createOrUpdateEvent)="createOrUpdateEntityInstance()" (showGroup)="showGroup($event)"
	(selectedEntityTypeChangedEvent)="selectedEntityTypeChanged($event)"
	(refreshInstanceDataEvent)="refreshInstanceData()">
</app-entity-instance-dialog>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>
<app-show-group-dialog #showGroupDialog></app-show-group-dialog>
<app-manage-groups-dialog #manageGroupsDialog></app-manage-groups-dialog>
<app-add-to-group-dialog #addToGroupDialog (confirmEvent)="addSelectedToGroup($event)"></app-add-to-group-dialog>
<app-remove-from-group-dialog #removeFromGroupDialog (confirmEvent)="removeSelectedFromGroup($event)">
</app-remove-from-group-dialog>

<!-- Right Click dropdown menu -->
<app-dropdown-menu *ngIf="showContextMenu" [x]="contextMenuPosition.x" [y]="contextMenuPosition.y"
	[items]="functionList" (selectedItemChange)="onItemClicked($event)"></app-dropdown-menu>

<!-- Going further if we want to display the function execution status
	<app-function-executing-dialog  #functionExecutingDialog (functionExecutionStartEvent)="functionStartingToExecute($event)" (functionExecutionSuccessEvent)="functionFinishedExecutingSuccessfully()" (functionExecutionErrorEvent)="functionFinishedExecutingWithError($event)"></app-function-executing-dialog> -->

<app-general-function-dialog *ngIf="showGeneralDialog" #generalDialog [instance]="mInstance"
	[instanceType]="mInstanceType" [function]="selectedFunction"></app-general-function-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>